import { Waypoints } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const WaypointsIcon = createLucideIcon(Waypoints);
